import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const unlockOperationsRoute: InvariantJiraRoute = {
	name: 'eoc-unlock-operations',
	path: '/jira/settings/products/ops/unlock',
	exact: true,
};
